import { Dispatch, SetStateAction } from 'react'
import { IOrder } from '../../../../app/entities/Order'
import { removeFreeOrderReason } from '../../schedule/components/api'
import { ISchedulerStateProps } from '../../schedule/components/schedule-modal/components/container-modal/initialData'
import { fetchData } from './fetch'

async function removeFreeOrderReasonAndCalculateCosts(
  schedulerState: ISchedulerStateProps,
  setSchedulerState: Dispatch<SetStateAction<ISchedulerStateProps>>,
) {
  fetchData<IOrder>(removeFreeOrderReason(schedulerState.orderId))

  setSchedulerState({
    ...schedulerState,
    freeOrderReason: {
      objectId: '',
      reason: '',
      isFree: false,
    },
  })
}

export default removeFreeOrderReasonAndCalculateCosts
